import {
  Culture,
  Football,
  Museum,
  Nature,
  Playground,
  Pool,
  Research,
  Workshop,
} from "../components/Icons/CustomIcons";

export const CATEGORIES = [
  { id: 1, name: "Sport & Bewegung", slug: "sport", icon: Football },
  { id: 2, name: "Kultur & Kunst", slug: "kultur", icon: Culture },
  { id: 3, name: "Natur & Tiere", slug: "natur", icon: Nature },
  { id: 4, name: "Museen & Ausstellungen", slug: "museen", icon: Museum },
  { id: 5, name: "Spielplätze", slug: "spielplaetze", icon: Playground },
  { id: 6, name: "Schwimmbäder", slug: "schwimmbaeder", icon: Pool },
  {
    id: 7,
    name: "Forschung & Experiment",
    slug: "forschung-und-experiment",
    icon: Research,
  },
  { id: 8, name: "Workshops", slug: "workshops", icon: Workshop },
];

export const INDOOR_OUTDOOR_OPTIONS = [
  { value: "indoor", label: "Drinnen" },
  { value: "outdoor", label: "Draussen" },
  { value: "both", label: "Beides" },
];

export const COST_RANGE_OPTIONS = [
  { value: "free", label: "Gratis" },
  { value: "low", label: "Günstig (< CHF 20)" },
  { value: "medium", label: "Mittel (CHF 20-50)" },
  { value: "high", label: "Teuer (> CHF 50)" },
];

export const DURATION_OPTIONS = [
  { value: "short", label: "Kurz (< 1h)" },
  { value: "medium", label: "Mittel (1-2h)" },
  { value: "halfday", label: "Halbtag (2-4h)" },
  { value: "fullday", label: "Ganztag (> 4h)" },
  { value: "multiday", label: "Mehrtägig" },
];
